import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import StoreMap from "../components/StoreMap";
import AppHeader from "../components/AppHeader";
import ItemDetails from "../components/ItemDetails";
import { Dimmer, Loader } from 'semantic-ui-react'
import LocationSelector from "../components/LocationSelector";
import { apiCall } from "../util/Api";
export default function DefaultLayout() {

    // Default location is bookmanager office in kelowna
    const [location, setLocation] = useState({ "latitude": null, "longitude": null });
    const [loading, setLoading] = useState(true);
    const [storesLoading, setStoresLoading] = useState(true);
    const [isUSA, setIsUSA] = useState(false);
    const [pc, setPc] = useState("")

    // Request location from the browser 
    const getLocation = () => {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setLocation({ latitude: position.coords.latitude, longitude: position.coords.longitude });
                setLoading(false);
            }, () => {
                setLoading(false);
            });
        } else {
            setLoading(false);
        }
    }

    useEffect(getLocation, []);



    const fetchStores = (_postalCode = pc) => {

        if (!location) {
            return;
        }

        setStoresLoading(true);

        let obj = {
            api_key: "12sC3vdedypUpGC3HDt4AK9F19c6QHbz",
            isbn: isbn,
            distance_km: range,
        }

        // If postal code, use postal code
        if (_postalCode) {
            
            obj.postal = _postalCode;
        } else {
            // if no postal code, use geo 
            if (location.latitude && location.longitude) {
                obj.latitude = location.latitude;
                obj.longitude = location.longitude;
            } else {
                // not enough data to request, set to empty
                setStores({ rows: [] })
                setStoresLoading(false);
                return;
            }

        }

     

        apiCall("tbm/nearbyStores/get", obj, (_status, _results) => {


            if (_status) {

                setStores(_results);
                setStoresLoading(false);

                if(_results?.country === "usa"){
                    setIsUSA(true);
                } else {
                    setIsUSA(false);
                }

                if (_postalCode) {
                    setSelected(_results.rows[0]);
                    setPc(_postalCode);
                }

            } else {
                setStores({ rows: [] })
                setStoresLoading(false);
            }
        })
    }


    // Parent vars shared between StoreMap and LocationSelector
    let { isbn = "" } = useParams();
    isbn = isbn.replace(/[^a-zA-Z0-9]/g, "");
    const [stores, setStores] = useState({ rows: [] })
    const [range, setRange] = useState(25);
    const [mapView, setMapView] = useState(false);
    const [selected, setSelected] = useState(false)


    
    useEffect(fetchStores, [location, range])

    // Show nothing while loading
    if (loading) {
        return (<>

            <Dimmer inverted active>
                <img style={{ "maxWidth": "200px", "marginTop": "-100px", "position": "absolute", "left": "calc(50% - 100px)" }} src="https://bookmanager.com/public/api/btns/Shop Local Text.svg" />
                <Loader inverted><br />Fetching location...</Loader>
            </Dimmer>

        </>)
    }




    // Draw container + pass vars / methods to components
    return (
        <>
            <div className="wrap" >
                <AppHeader mapView={mapView} setMapView={setMapView} />
                <ItemDetails isUSA={isUSA} isbn={isbn} mapView={mapView} />
                <LocationSelector pc={pc} loading={storesLoading} fetchStores={fetchStores} isUSA={isUSA} location={location} setSelected={setSelected} isbn={isbn} mapView={mapView} setMapView={setMapView} range={range} setRange={setRange} stores={stores} setStores={setStores} />
            </div>
            <StoreMap location={location} isbn={isbn} selected={selected} mapView={mapView} range={range} stores={stores}></StoreMap>
        </>
    )
}